import React from 'react';
import styled from 'styled-components';

import { useModalObject } from '@front/common/src/hooks/use-modal';

import { EligibleProsCountProps } from '@front/customer/src/components/basket/types';

import { translate } from '@front/i18n';

import Accordion from '@front/web-ui/src/components/accordion/accordion';
import Text from '@front/web-ui/src/components/base-text/variants/text';
import TextButton from '@front/web-ui/src/components/button/text-button';
import Separator from '@front/web-ui/src/components/separator/separator';

import EligibleProsCountModal from './eligible-pros-count-modal';

export const ELIGIBLE_PROS_BASKET_SECTION_TEST_ID = 'ELIGIBLE_PROS_BASKET_SECTION_TEST_ID';

const t = translate('basket.eligible_pros_count');

const StyledAccordion = styled(Accordion)`
  margin: 20px 0;
`;

const EligibleProsCount = ({ universeRef }: EligibleProsCountProps) => {
  const { isOpen, open, close } = useModalObject();

  return (
    <>
      <EligibleProsCountModal isOpen={isOpen} onClose={close} universeRef={universeRef} />
      <Separator />
      <StyledAccordion
        icon='person-filled'
        title={t('.several_pros_found')}
        testId={ELIGIBLE_PROS_BASKET_SECTION_TEST_ID}
      >
        <Text display='inline'>{`${t('.text')} `}</Text>
        <TextButton onClick={open}>{t('base.learn_more')}</TextButton>
      </StyledAccordion>
    </>
  );
};

export default EligibleProsCount;
